// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a5bfb39e38067d9a1608","655":"c925cdef4542a1af0fc6"}[chunkId] + ".js";
};